import { ButtonProps } from '@vkontakte/vkui';
import { useContext, useRef } from 'react';
import { L } from '@lang';
import { imageGetters, SOCIALS } from '../../../../helpers';
import { AppContext } from '../../../../contexts';
import { useScrollAnalytics } from '../useScrollAnalytics';
import { MainState } from './types';

export function useMainState(): MainState {
  const { deviceType } = useContext(AppContext);

  const sentinelStoreBlockRef = useRef<HTMLDivElement>(null);

  useScrollAnalytics();

  const aboutSection = {
    subtitle: L.t('crush_landing_about_subtitle'),
    text: L.t('crush_landing_about_text'),
    imageUrl: imageGetters.crush.avatars(),
  };

  const storeSection = {
    sentinelStoreBlockRef,
  };

  const socialsButtonsProps: ButtonProps[] = SOCIALS.map(({ type, icons, url }) => {
    const Icon = icons[deviceType === 'mobile' ? 24 : 36];
    return {
      style: deviceType === 'mobile' ? { minHeight: '50px' } : {},
      before: <Icon style={{ verticalAlign: 'middle' }} />,
      mode: 'primary',
      children: L.t('crush_social_entry_button', { context: type }),
      size: deviceType === 'mobile' ? 'm' : 'l',
      href: url,
      rel: 'noreferrer noopener',
      target: '_blank',
      stretched: true,
    } as const;
  });

  return {
    deviceType,
    contestFinishingSection: {
      type: 'results',
      subtitle: L.t('crush_finishing_section_results'),
      buttons: socialsButtonsProps,
    },
    aboutSection,
    storeSection,
  };
}
